module.exports = __webpack_public_path__ + "static/img/email.78bc3423.png";